import { Box, BoxProps } from '@material-ui/core';

const TableHorizontalAxis: React.ComponentType<BoxProps> = (props) => <Box display="flex" flexDirection="row" {...props} />;

export default TableHorizontalAxis;
